var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 20.375C16.2917 21.0208 17.0833 21.3438 18 21.3438C18.9167 21.3438 19.6979 21.0208 20.3438 20.375C21.0104 19.7083 21.3438 18.9167 21.3438 18C21.3438 17.0833 21.0104 16.3021 20.3438 15.6562C19.6979 14.9896 18.9167 14.6562 18 14.6562C17.0833 14.6562 16.2917 14.9896 15.625 15.6562C14.9792 16.3021 14.6562 17.0833 14.6562 18C14.6562 18.9167 14.9792 19.7083 15.625 20.375ZM16 11.3438H20L21.2188 12.6562H23.3438C23.6979 12.6562 24 12.7917 24.25 13.0625C24.5208 13.3333 24.6562 13.6458 24.6562 14V22C24.6562 22.3542 24.5208 22.6667 24.25 22.9375C24 23.2083 23.6979 23.3438 23.3438 23.3438H12.6562C12.3021 23.3438 11.9896 23.2083 11.7188 22.9375C11.4688 22.6667 11.3438 22.3542 11.3438 22V14C11.3438 13.6458 11.4688 13.3333 11.7188 13.0625C11.9896 12.7917 12.3021 12.6562 12.6562 12.6562H14.7812L16 11.3438ZM16.5 19.5C16.0833 19.0833 15.875 18.5833 15.875 18C15.875 17.4167 16.0833 16.9167 16.5 16.5C16.9167 16.0833 17.4167 15.875 18 15.875C18.5833 15.875 19.0833 16.0833 19.5 16.5C19.9167 16.9167 20.125 17.4167 20.125 18C20.125 18.5833 19.9167 19.0833 19.5 19.5C19.0833 19.9167 18.5833 20.125 18 20.125C17.4167 20.125 16.9167 19.9167 16.5 19.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/profile-camera.7ae3428a7734dd552b4b69ba26f19458.svg";
export { ForwardRef as ReactComponent };